import styled from 'styled-components'
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const GROUPS = [
  { role: 'finding_photo', title: 'Photos of the issue', hint: 'Taken when the problem was found.' },
  { role: 'evidence_of_completion', title: 'Evidence it was put right', hint: 'Added when the work was done.' },
  { role: 'attachment', title: 'Other attachments', hint: 'Documents and photos added along the way.' },
]

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'heic', 'webp', 'bmp']

const RemedialFiles = ({ files, onOpen }) => {
  if (!files?.length) return null

  return (
    <Wrap>
      <Title>Photos and evidence</Title>
      {GROUPS.map(group => {
        const items = files.filter(file => (file.role || 'attachment') === group.role)
        if (!items.length) return null
        return (
          <Group key={group.role}>
            <GroupHead>
              <strong>{group.title}</strong>
              <span>{group.hint}</span>
            </GroupHead>
            <Items>
              {items.map(file => {
                const restricted = file.isIdentityRestricted
                const Icon = restricted ? LockOutlinedIcon : IMAGE_EXTENSIONS.includes(file.extension) ? ImageOutlinedIcon : DescriptionOutlinedIcon
                if (restricted || file.deleted) {
                  return (
                    <Plain key={file.id} title={restricted ? 'This file is protected because it may contain personal identity details.' : 'This file has been deleted.'}>
                      <Icon style={{ fontSize: 18 }} aria-hidden='true' />
                      <span>{file.displayName}</span>
                      <Small>{restricted ? 'Protected' : 'Deleted'}</Small>
                    </Plain>
                  )
                }
                return (
                  <FileButton key={file.id} type='button' onClick={() => onOpen(file)} aria-label={`Open ${file.displayName}`}>
                    <Icon style={{ fontSize: 18 }} aria-hidden='true' />
                    <span>{file.displayName}</span>
                    <OpenInNewIcon style={{ fontSize: 14, opacity: 0.7 }} aria-hidden='true' />
                  </FileButton>
                )
              })}
            </Items>
          </Group>
        )
      })}
    </Wrap>
  )
}

export default RemedialFiles

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

const Title = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.grey?.[800] || '#64748b'};
  font-weight: 600;
`

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const GroupHead = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.haiti};
  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey?.[800] || '#64748b'};
  }
`

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const FileButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #cfeef2;
  background: #f0fbfc;
  color: #0e6f7a;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:hover { background: #e0f6f9; }
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`

const Plain = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  color: #475569;
  font-size: 14px;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const Small = styled.small`
  font-size: 12px;
  color: #64748b;
`
